import { render, staticRenderFns } from "./maintenanceStaff.vue?vue&type=template&id=32a06d1a&"
import script from "./maintenanceStaff.vue?vue&type=script&lang=js&"
export * from "./maintenanceStaff.vue?vue&type=script&lang=js&"
import style0 from "./maintenanceStaff.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports